import {Divider} from '@/components/ui/divider/Divider'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {MedicalReportTextAreaSections} from '../medical-report-text-area-sections/MedicalReportTextAreaSections'
import {startProjectRehabilitationToSection, startProjectReportToSection} from '../../utils'
import {StartProjectRehabilitationSchema, StartProjectReportsSchema} from '../../formSchemas'

export const StartContinuousProjectSections = () => {
    return (
        <>
            <ReportSections />
            <Divider direction="horizontal" />
            <RehabilitationSections />
        </>
    )
}

const ReportSections = () => {
    const {t} = useTranslation()
    return (
        <>
            <MedicalReportSectionTitle>{t('commons:report', {count: 1})}</MedicalReportSectionTitle>
            <MedicalReportTextAreaSections
                sectionsMap={startProjectReportToSection}
                schema={StartProjectReportsSchema}
            />
        </>
    )
}

const RehabilitationSections = () => {
    const {t} = useTranslation()
    return (
        <>
            <MedicalReportSectionTitle>{t('commons:rehabilitation_project', {count: 1})}</MedicalReportSectionTitle>
            <MedicalReportTextAreaSections
                sectionsMap={startProjectRehabilitationToSection}
                schema={StartProjectRehabilitationSchema}
            />
        </>
    )
}
